module.exports = __webpack_public_path__ + "static/media/youtubeLogo.eb6c4c9d.png";